import FreeBet from './FreeBet';

export default FreeBet;
